import * as array from 'd3-array'

export default function (data, scalers, scale, event, chart) {
  let scrollLeft = document.documentElement.scrollLeft ? document.documentElement.scrollLeft : document.body.scrollLeft
    , pos = (event.pageX - scrollLeft - this.getBoundingClientRect().left) * (1 / scale)

  if (chart.layout.rtl) {
    // In RTL mode, the position is calculated from the right side of the chart
    pos = this.getBoundingClientRect().width - pos
  }

  let bisector = array.bisector(d => d.title).left
    , lines = data.series.filter(s => s.type === 'line') // don't show the goal series
    , x = scalers.x.groupScale.invert(pos)
    , i = bisector(lines[0].points, x, 1)
    , d0 = lines[0].points[i - 1]
    , d1 = lines[0].points[i]
    , d = d1 && x - d0.title > d1.title - x ? d1 : d0
    , idx = lines[0].points.indexOf(d)

  return lines.map(function (s) {
    let point = s.points[idx]
      , axis = s.axis || 'left'
      , format = chart.layout.getFormatter(axis)

    if (!point) {
      return null
    }

    return {
      raw: point.raw,
      range: point._range,
      rangeId: d.rangeId,
      x: d,
      title: d.title,
      axis,
      color: s.color,
      text: point.formatted || format(point.raw),
      header: chart.datum().tooltip.header.formatter(point.title),
    }
  }).filter(Boolean)
}
